module.exports = __webpack_public_path__ + "static/media/step2-backg.56a98cf9.png";